import {Activity, ActivityType} from '../activity';
import {Observable} from 'rxjs';
import {stripXMLPrefix} from '../ctrl-processdesigner.component';
import {LazyDialogService} from './lazy-dialog.service';
import * as convert from 'xml-js';

export class UnknownActivity extends Activity {
  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.UNKNOWN);
    this.parse(activityNode);
  }

  private activityNode: any;
  private activityTypeName: string;
  public attributes: any;
  public content: string;

  protected parse(activityNode: any): void {
    this.activityNode = activityNode;

    if (activityNode == null) {
      return;
    }

    if (activityNode.name) {
      this.activityTypeName = stripXMLPrefix(activityNode.name);
    }

    this.attributes = {};
    for (let xmlKey in activityNode.$) {
      let key = stripXMLPrefix(xmlKey);
      this.attributes[key] = activityNode.$[xmlKey];
    }

    this.content = '';
    if (activityNode.elements) {
      let obj = {
        name: 'elements',
        type: 'element',
        elements: activityNode.elements,
      };
      this.content = convert.js2xml(obj, {
        attributesKey: '$',
      });
    }
  }

  public objForXML(): any {
    const obj = Object.assign({}, this.activityNode);
    for (let xmlKey in obj.$) {
      let key = stripXMLPrefix(xmlKey);
      obj.$[xmlKey] = this.attributes[key];
    }

    try {
      obj.elements = convert.xml2js(this.content, {attributesKey: '$'}).elements;
    } catch (e) {
      obj.elements = [];
    }
    return obj;
  }

  get className(): string {
    return this.activityTypeName;
  }

  get isUnknown(): boolean {
    return true;
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('unknown', this.dialogConfig);
  }
}
